<template>
  <div class="TopInfo">
    <div class="top-container">
      <div class="left-area">
        <div class="logo">
          <img :src="detail.shippingLogo || require('@/images/point.png')" />
        </div>
        <div class="port portNone">
          <div class="en" :title="detail.portStartName">
            {{ $str(stamp2StrMD(detail.etd), "", "${}/")
            }}<span class="is-port">{{ detail.portStartName }}</span>
          </div>
        </div>
        <div class="transfer-area">
          <div class="transfer-via" v-if="detail.transferFlag == '中转'">
            <div class="row-1">
              {{ $str(detail.voyage, "", "${}天") }}
            </div>
            <div class="row-2">
              <div class="spot-dian"></div>
              <div class="spot-line"></div>
              <div class="spot-dian"></div>
            </div>
            <div class="row-1" :title="$str(detail.transferName, '', '${} 转')">
              {{ $str(detail.transferName, "中转", "${} 转") }}
            </div>
          </div>
          <div class="transfer-dir" v-else>
            <div class="spot">
              <div class="spot-dian"></div>
              <div class="spot-line"></div>
            </div>
            <div
              class="transfer-text"
              :title="$str(detail.voyage, '', '直达${}天')"
            >
              {{ $str(detail.voyage, "直达", "直达${}天") }}
            </div>
            <div class="spot">
              <div class="spot-line"></div>
              <div class="spot-dian"></div>
            </div>
          </div>
        </div>
        <div class="port">
          <div class="en" :title="detail.portEndName">
            {{ $str(stamp2StrMD(detail.eta), "", "${}/")
            }}<span class="is-port">{{ detail.portEndName }}</span>
          </div>
        </div>
      </div>
      <div class="right-area">
        <div class="right-li">
          <div
            class="li-value slh_one"
            :title="shipNameNum(detail.shipName, detail.voyageNum)"
          >
            {{ shipNameNum(detail.shipName, detail.voyageNum) }}
          </div>
          <div class="li-label">船名航次</div>
        </div>
        <div class="right-li">
          <div
            class="li-value slh_one"
            :title="$str(detail.routeCode, '', '${}')"
          >
            {{ $str(detail.routeCode, "-", "${}") }}
          </div>
          <div class="li-label">航线代码</div>
        </div>
        <div class="right-li">
          <div class="li-value slh_one">
            {{ $str(chooseContainerType, "-", "${}") }}
          </div>
          <div class="li-label">箱型</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from "@/utils/DateTime";
export default {
  props: {
    detail: {
      type: Object,
      default: () => ({}),
    },
    chooseContainerType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  //初始化
  mounted() {
    console.log("--------detail", this.detail);
  },

  methods: {
    stamp2StrMD(stamp) {
      if (!stamp) return "";
      return DateTime.formatToStr(new Date(stamp), "MM.DD");
    },
    shipNameNum(shipName, voyageNum) {
      if (!this.$isInputEmpty(shipName) && !this.$isInputEmpty(voyageNum)) {
        return `${shipName}/${voyageNum}`;
      } else if (!this.$isInputEmpty(shipName)) {
        return shipName;
      } else if (!this.$isInputEmpty(voyageNum)) {
        return voyageNum;
      } else {
        return "-";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.TopInfo {
  padding: 0 0 0 24px;
  .top-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 26px;
    margin-top: -6px;
    $rightWidth: 436px;
    .left-area {
      width: calc(100% - #{$rightWidth});
      padding-right: 24px;
      // overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .logo {
        width: 48px;
        height: 48px;
        background: #ffffff;
        border: 1px solid #e4e7ee;
        box-shadow: -1px 6px 24px 0px rgba(1, 7, 24, 0.04);
        border-radius: 10px;
        margin-right: 18px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex: none;
        img {
          // width: 100%;
          // height: 100%;
          width: 38px;
          height: 38px;
          object-fit: contain;
        }
      }
      .port {
        overflow: hidden;
        .en {
          width: 100%;
          font-size: 18px;
          font-weight: bold;
          color: #212529;
          // margin-bottom: 2px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          .is-port {
            font-size: 16px;
          }
        }
        .cn {
          width: 100%;
          font-size: 12px;
          font-weight: 500;
          color: #484851;
        }
      }
      .portNone {
        display: flex;
        flex-direction: column;
        flex: none;
        .en {
          max-width: 200px;
        }
      }
      .transfer-area {
        $transferWidth: 120px;
        padding: 0 20px;
        display: flex;
        flex: none;
        font-size: 14px;
        font-weight: 500;
        color: #61667c;
        .transfer-via {
          width: $transferWidth;
          .row-1 {
            width: 100%;
            padding: 0 10px;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          .row-2 {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .spot-dian {
              width: 10px;
              height: 10px;
              background: #fbfbfb;
              border: 2px solid #dfe2ec;
              border-radius: 50%;
            }
            .spot-line {
              width: calc(#{$transferWidth} - 10px - 10px);
              height: 2px;
              background: #dfe2ec;
            }
          }
        }
        .transfer-dir {
          width: $transferWidth;
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex: none;
          .spot {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .spot-dian {
              width: 10px;
              height: 10px;
              background: #fbfbfb;
              border: 2px solid #dfe2ec;
              border-radius: 50%;
            }
            .spot-line {
              width: 14px;
              height: 2px;
              background: #dfe2ec;
            }
          }
          .transfer-text {
            padding: 0 4px;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
        }
      }
    }
    .right-area {
      width: $rightWidth;
      height: 64px;
      padding: 0 24px;
      // background: linear-gradient(90deg, #f4f6fa 0%);
      // background: linear-gradient(90deg, #f0f4f9, rgba(240, 244, 249, 0.5));
      background: linear-gradient(90deg, #f0f4f9, rgba(240, 244, 249, 0));
      border-radius: 10px;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .right-li {
        display: flex;
        flex-direction: column;
        margin-right: 40px;
        overflow: hidden;
        min-width: 60px;
        &:first-child {
          max-width: 137px;
        }
        &:last-child {
          margin-right: 0 !important;
          display: flex;
          flex: none;
        }
        .li-value {
          width: 100%;
          font-size: 14px;
          font-weight: bold;
          color: #323239;
          margin-bottom: 6px;
        }
        .li-label {
          font-size: 13px;
          font-weight: 500;
          color: #61667c;
        }
      }
    }
  }
}
</style>
